import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const userProfileConstants = {
    USER_DATA_LOADED: 'USER_DATA_LOADED',
    USER_DATA_CLEARED: 'USER_DATA_CLEARED',
    USER_INFO_LOADED: 'USER_INFO_LOADED',
    USER_FIND_DATA_LOADED: 'USER_FIND_DATA_LOADED',
};

export const userProfileFulfilledConstants = getActionTypesResult(userProfileConstants, '_FULFILLED');
export const userProfilePendingConstants = getActionTypesResult(userProfileConstants, '_PENDING');
export const userProfileRejectedConstants = getActionTypesResult(userProfileConstants, '_REJECTED');

export const clearUserData = () => ({
    type: userProfileConstants.USER_DATA_CLEARED
});

export const fetchUserData = createAsyncAction(userProfileConstants.USER_DATA_LOADED, query =>
    api.get('users/equipment', { params: query, paramsSerializer: { indexes: null } }).then(res => res.data)
);

export const fetchUserInfo = createAsyncAction(userProfileConstants.USER_INFO_LOADED, user =>
    api.get(`users/${user}/info`).then(res => res.data)
);

export const fetchFindUserData = createAsyncAction(userProfileConstants.USER_FIND_DATA_LOADED, userId =>
    api.get(`users/${userId}/equipment`).then(res => res.data)
);
